import React from 'react';

const PatientPreview = ({ providerInfo }) => {
  const patientFullName = `${providerInfo?.patient_f_name} ${providerInfo?.patient_l_name}`.trim();
  const patientAge = providerInfo?.patient_age;

  return (
    <div className="flex w-full flex-col">
      <div className="text-base font-500 text-neutral-800">Patient</div>
      <div className="flex flex-col">
        <p className="mt-1.5 text-sm font-400 text-neutral-800 first-of-type:!mt-2.5">
          {patientFullName}
        </p>
      </div>
      {patientAge >= 0 && (
        <div className="flex flex-col">
          <p className="mt-1.5 text-sm font-400 text-neutral-800 first-of-type:!mt-2.5">
            {patientAge} years old
          </p>
        </div>
      )}
    </div>
  );
};

export default PatientPreview;
